module.exports = __webpack_public_path__ + "6dbc8d1e49d30c0db476ac9ebea4e2b8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-20.png
// module id = 2598
// module chunks = 0